import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@fontsource/inter";
import LandingPage from "./pages/public/LandingPage";
// import {
//   FingerprintJSPro,
//   FpjsProvider,
// } from "@fingerprintjs/fingerprintjs-pro-react";
import { Provider } from "react-redux";
import { store } from "./store/store";

import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TaskSubmissionPage from "./pages/public/TaskSubmissionPage";
import PaymentProcessingPage from "./pages/status/PaymentProcessingPage";
import PaymentProcessingFB from "./pages/status/PaymentProcessingFB";


import DesktopBlocker from "./components/common/DesktopBlocker";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Component to track PageView on route changes (excluding payment pages)
const PageViewTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Skip PageView for payment-processing pages
    if (location.pathname !== '/payment-processing' && location.pathname !== '/payment-processing-fb') {
      if ((window as any).fbq) {
        (window as any).fbq('track', 'PageView');
      }
    }
  }, [location]);

  return null;
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <DesktopBlocker />
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter basename="/">
          <PageViewTracker />

          {/* <FpjsProvider
            loadOptions={{
              apiKey: "LAQ3MT1FHparLBFLpNdg",
              // endpoint: [
              //   "https://metrics.app20.in",
              //   FingerprintJSPro.defaultEndpoint,
              // ],
              // scriptUrlPattern: [
              //   "https://metrics.app20.in/web/v<version>/<apiKey>/loader_v<loaderVersion>.js",
              //   FingerprintJSPro.defaultScriptUrlPattern,
              // ],
              region: "ap",
            }}
          > */}
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/ios" element={<LandingPage />} />
            <Route path="/ios/:amount" element={<LandingPage />} />
            <Route path="/submit-task" element={<TaskSubmissionPage />} />
            <Route path="/payment-processing" element={<PaymentProcessingPage />} />
            <Route path="/payment-processing-fb" element={<PaymentProcessingFB />} />

            <Route path="*" element={<LandingPage />} />
          </Routes>

          {/* </FpjsProvider> */}
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);
